module.exports = "https://static.zego.com/_next/static/images/Aldium-6bd39015e19ba59857f9badf041644db.svg";